import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes } from './types';

export const onSiteSelectorShown = ({
	commonAttributes,
}: {
	commonAttributes: CommonAttributes;
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: 'siteSelector',
	action: 'shown',
	attributes: {
		commonAttributes,
	},
});
